document.addEventListener("DOMContentLoaded", () => {
  const modals = document.querySelectorAll("[data-csq-modal]");

  if (modals) {
    const body = document.querySelector("body");
    const bgElement = document.createElement("div");

    modals.forEach((trigger) => {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();

        const modal = document.getElementById(trigger.dataset["csqModal"]);

        body.after(bgElement);
        modal.classList.add("csq-modal-open");

        bgElement.classList.add("csq-modal-bg");
        bgElement.classList.add("csq-modal-close");

        const closes = document.querySelectorAll(".csq-modal-close");

        closes.forEach((close) => {
          close.addEventListener("click", (event) => {
            event.preventDefault();

            bgElement.remove();

            modal.classList.remove("csq-modal-open");
          });
        });
      });
    });
  };
}, false);
